const chainId = 4002;
export default chainId;